import { ButtonGroup, ButtonToolbar, Container } from 'react-bootstrap';
import BootstrapSelect from 'react-bootstrap-select-dropdown';
import { dropdownStyle } from '../../../../auth';
import './style.css';
import { useEffect, useMemo } from 'react';
import Select from 'react-select';
import { useMedicationMedCatalogue } from './context/MedicationMedCatalogueProvider';

const yesNoAlloptions = [
  {
    label: 'All',
    value: undefined,
  },
  {
    label: 'Yes',
    value: true,
  },
  {
    label: 'No',
    value: false,
  },
];

export const MedicationProfileSettingsFilter = ({
  form,
  handleFilterChange,
}) => {
  const { catalogOptions } = useMedicationMedCatalogue();
  const { indicationOptions, therapeuticAreaOptions, therapeuticClassOptions } =
    catalogOptions;

  const {
    register,
    handleSubmit,
    watch,
    control,
    formState: { errors, value },
    reset: resetForm,
    getValues,
  } = form;

  const dosingScheduleValue = watch('isDoseSchedule');
  const prnValue = watch('isPrn');
  const taperValue = watch('isTaper');

  const therapeuticClassValue = watch('therapeuticClass');
  const indicationValue = watch('indication');
  const therapeuticAreaValue = watch('therapeuticArea');

  const indicationSelectOptions = useMemo(() => {
    return [
      {
        value: '',
        label: 'All',
      },
      ...indicationOptions.map((item) => {
        return {
          value: item,
          label: item,
        };
      }),
    ];
  }, [indicationOptions]);

  const therapeuticAreaSelectOptions = useMemo(() => {
    return [
      {
        value: '',
        label: 'All',
      },
      ...therapeuticAreaOptions.map((item) => {
        return {
          value: item,
          label: item,
        };
      }),
    ];
  }, [therapeuticAreaOptions]);

  const therapeuticClassSelectOptions = useMemo(() => {
    return [
      {
        value: '',
        label: 'All',
      },
      ...therapeuticClassOptions.map((item) => {
        return {
          value: item,
          label: item,
        };
      }),
    ];
  }, [therapeuticClassOptions]);

  useEffect(() => {
    // options are provided by the context provider; no need to fetch here
  }, []);

  return (
    <>
      <form>
        <div className="medication-filter-container">
          <Container fluid>
            <div className="filterBg">
              <div className="medication-filter-container-row">
                <div className="filterItem patientName">
                  <div>
                    <label className="txtDropdownLabel">Med name</label>
                  </div>

                  <div>
                    <input
                      type="text"
                      label="Med name"
                      name="Medname"
                      className="med-name-input"
                      placeholder="Search by med name"
                      {...register('medName')}
                    />
                  </div>
                </div>

                <div className="filterItem">
                  <div>
                    <label className="txtDropdownLabel">Indication</label>
                  </div>
                  <div className="divSelect">
                    <Select
                      onChange={(selectedOptions) => {
                        const indication = selectedOptions.value;
                        form.setValue('indication', indication);
                      }}
                      value={
                        indicationSelectOptions.find(
                          (opt) => opt.value === indicationValue,
                        ) ?? indicationSelectOptions[0]
                      }
                      placeholder={'All'}
                      style={dropdownStyle}
                      options={indicationSelectOptions}
                      isMulti={false}
                      showTick={true}
                    />
                  </div>
                </div>

                <div className="filterItem">
                  <div>
                    <label className="txtDropdownLabel">Therapeutic area</label>
                  </div>

                  <div className="divSelect">
                    <Select
                      onChange={(selectedOptions) => {
                        const therapeuticArea = selectedOptions.value;
                        form.setValue('therapeuticArea', therapeuticArea);
                      }}
                      placeholder={'All'}
                      value={
                        therapeuticAreaSelectOptions.find(
                          (opt) => opt.value === therapeuticAreaValue,
                        ) ?? therapeuticAreaSelectOptions[0]
                      }
                      style={dropdownStyle}
                      options={therapeuticAreaSelectOptions}
                      isMulti={false}
                      showTick={true}
                    />
                  </div>
                </div>

                <div className="filterItem">
                  <div>
                    <label className="txtDropdownLabel">
                      Therapeutic class
                    </label>
                  </div>

                  <div className="divSelect">
                    <Select
                      onChange={(selectedOptions) => {
                        const therapeuticClass = selectedOptions.value;
                        form.setValue('therapeuticClass', therapeuticClass);
                      }}
                      placeholder={'All'}
                      value={
                        therapeuticClassSelectOptions.find(
                          (opt) => opt.value === therapeuticClassValue,
                        ) ?? therapeuticClassSelectOptions[0]
                      }
                      style={dropdownStyle}
                      options={therapeuticClassSelectOptions}
                      isMulti={false}
                      showTick={true}
                    />
                  </div>
                </div>
              </div>

              <div
                className="medication-filter-container-row"
                style={{ justifyContent: 'space-between', display: 'flex' }}
              >
                <div style={{ display: 'flex' }}>
                  <div className="filterItem">
                    <div>
                      <label className="txtDropdownLabel">
                        Dosing schedule
                      </label>
                    </div>

                    <div className="divSelect">
                      <Select
                        onChange={(selectedOptions) => {
                          const isDoseSchedule = selectedOptions.value;
                          form.setValue('isDoseSchedule', isDoseSchedule, {
                            shouldDirty: true,
                            shouldValidate: true,
                          });
                        }}
                        placeholder={'All'}
                        value={
                          yesNoAlloptions.find(
                            (opt) => opt.value === dosingScheduleValue,
                          ) || ''
                        }
                        style={dropdownStyle}
                        options={yesNoAlloptions}
                        isMultiSelect={false}
                        showTick={true}
                      />
                    </div>
                  </div>
                  <div className="filterItem">
                    <div>
                      <label className="txtDropdownLabel">PRN</label>
                    </div>

                    <div className="divSelect">
                      <Select
                        onChange={(selectedOptions) => {
                          const isPrn = selectedOptions.value;
                          form.setValue('isPrn', isPrn);
                        }}
                        style={dropdownStyle}
                        value={
                          yesNoAlloptions.find(
                            (opt) => opt.value === prnValue,
                          ) || ''
                        }
                        placeholder={'All'}
                        options={yesNoAlloptions}
                        isMulti={false}
                        showTick={true}
                      />
                    </div>
                  </div>
                  <div className="filterItem">
                    <div>
                      <label className="txtDropdownLabel">Taper</label>
                    </div>

                    <div className="divSelect">
                      <Select
                        onChange={(selectedOptions) => {
                          const isTaper = selectedOptions.value;
                          form.setValue('isTaper', isTaper);
                        }}
                        placeholder={'All'}
                        value={
                          yesNoAlloptions.find(
                            (opt) => opt.value === taperValue,
                          ) || ''
                        }
                        style={dropdownStyle}
                        options={yesNoAlloptions}
                        isMulti={false}
                        showTick={true}
                      />
                    </div>
                  </div>
                </div>

                <div className="filterItem">
                  <div>
                    <ButtonToolbar aria-label="" className="filterBtns">
                      <ButtonGroup className="me-2" aria-label="First group">
                        <button
                          className="btn btnPrimary"
                          style={{ minWidth: 110 }}
                          type="button"
                          onClick={handleFilterChange}
                        >
                          Show results
                        </button>
                      </ButtonGroup>
                      <ButtonGroup>
                        <button
                          className="btn btnSecondary"
                          type="button"
                          onClick={() => {
                            resetForm();
                          }}
                        >
                          Clear
                        </button>
                      </ButtonGroup>
                    </ButtonToolbar>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </div>
      </form>
    </>
  );
};
